import * as React from "react";
import { navigate } from "~/router";
import { ProductUpdateRequest } from "~/apps/pos/models";
import ProductFormOverlay from "./ProductFormOverlay";
import { useEditProduct, useProductById } from "~/apps/pos/apis/products";
import { getProductFilter, getProductParams } from "~/apps/pos/shared/services/qsfilter";
import { useRoute } from "react-router5";

const ProductEditPopup = ({ productId }) => {
  const { route } = useRoute();
  const filter = getProductFilter(route.params);

  const { data: product, isLoading: getLoading } = useProductById(productId);
  const { mutate: onEdit, error, isLoading: editLoading } = useEditProduct();

  const handleClose = () => {
    navigate("pos.admin.products.all-products", getProductParams(filter));
  };

  const handleSubmit = (data: ProductUpdateRequest) => {
    onEdit(data, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const initialValues = {
    id: product?.id || "",
    name: product?.name || "",
    locationId: product?.locationId || "",
    categoryId: product?.categoryId || "",
    groupId: product?.group?.id || "",
    priority: product?.priority ?? null,
    type: product?.type || "",
    price: product?.price || "",
  };

  return (
    <ProductFormOverlay
      initialValues={initialValues}
      title="Edit product"
      error={error?.message || error?.errorMessage || ""}
      isLoading={getLoading || editLoading}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  );
};

export default ProductEditPopup;
